(function () {
  function progressForCount(count) {
    if (count >= 4) return 100;
    if (count === 3) return 66;
    if (count === 2) return 33;
    if (count === 1) return 16;
    return 0;
  }

  function updateCartTier(root) {
    if (!root) return;

    var count = parseInt(root.getAttribute('data-item-count'), 10) || 0;
    var track = root.querySelector('.cart-tier__track');
    if (track) {
      track.style.setProperty('--cart-tier-progress', progressForCount(count) + '%');
    }
  }

  function syncAll() {
    document.querySelectorAll('[data-cart-tier-progress]').forEach(updateCartTier);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }

  var drawer = document.querySelector('cart-drawer');
  if (drawer) {
    new MutationObserver(syncAll).observe(drawer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-item-count'],
    });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, syncAll);
  }
})();
